import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthHeaderService {

  constructor() { }
  getHeader() {
    const headerDict = {
      'Authorization': 'Bearer ' + localStorage.getItem('token'),
    };
    let authHeader = new HttpHeaders(headerDict);
    return authHeader;
  }

}
